import * as React from 'react';
import { Route, Switch } from 'react-router';
import { RouterError } from '../../app/spaces/RouterHelpers/RouterError';

import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { ReactDirectiveProps } from '../../ts/directives/reactDirectiveFactory';
import { FlowSpaceProvider } from './FlowSpaceProvider';

export interface FlowSpaceProps extends ReactDirectiveProps {
  readonly urls: SpacesSiteUrls;
  readonly routeLocationSearch: string;
  readonly routeLocationPath: string;
}

export const FlowSpaceRouter: React.FunctionComponent<FlowSpaceProps> = (props) => {
  const renderFlowSpaceProvider = (flowId: string, subplace: string) => (
    <FlowSpaceProvider
      angularContext={props.angularContext}
      flowId={flowId}
      siteUrls={props.urls}
      subplaceName={subplace}
      routeLocationSearch={props.routeLocationSearch}
      routeLocationPath={props.routeLocationPath}
    />
  );

  return (
    <Switch>
      <Route exact path={props.urls.flowOverviewPath(':id')} render={({ match }) => renderFlowSpaceProvider(match.params.id, 'overview')}/>
      <Route exact path={props.urls.flowConnectionsPath(':id')} render={({ match }) => renderFlowSpaceProvider(match.params.id, 'connections')}/>
      <Route exact path={props.urls.flowScheduledTasksPath(':id')} render={({ match }) => renderFlowSpaceProvider(match.params.id, 'scheduledTasks')}/>
      <Route exact path={props.urls.flowRunHistoryPath(':id')} render={({ match }) => renderFlowSpaceProvider(match.params.id, 'runHistory')}/>
      <Route path={props.urls.flowLineagePath(':id')} render={({ match }) => renderFlowSpaceProvider(match.params.id, 'lineage')}/>
      <Route render={() => <RouterError errorType={'default'} urls={props.urls}/>}/>
    </Switch>
  );
};
